import { render, staticRenderFns } from "./SolutionMasterList.vue?vue&type=template&id=704865fa&"
import script from "./SolutionMasterList.vue?vue&type=script&lang=js&"
export * from "./SolutionMasterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports